class SmartSearchOverlay {
  constructor() {
    this.overlay = document.querySelector('[data-search-overlay]');
    this.trigger = document.querySelector('[data-search-trigger]');
    this.closeBtn = document.querySelector('[data-search-close]');
    this.input = document.querySelector('[data-search-input]');
    this.results = document.querySelector('[data-search-results]');
    this.recentContainer = document.querySelector('[data-recent-searches]');

    if (!this.overlay || !this.trigger) {
      return;
    }

    this.searchUrl = this.overlay.dataset.searchUrl;

    this.abortController = null;
    this.debounceTimer = null;

    this.init();
  }

  init() {
    this.bindEvents();
    this.renderRecentSearches();
  }

  bindEvents() {
    this.trigger.addEventListener('click', () => {
      this.open();
    });

    this.closeBtn.addEventListener('click', () => {
      this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });

    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) {
        this.close();
      }
    });

    this.input.addEventListener('input', (event) => {
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.search(event.target.value);
      }, 250);
    });
  }

  open() {
    this.overlay.classList.add('active');
    document.body.classList.add('search-overlay-open');

    setTimeout(() => {
      this.input.focus();
    }, 100);
  }

  close() {
    this.overlay.classList.remove('active');
    document.body.classList.remove('search-overlay-open');
  }

  async search(query) {
    if (!query.length) {
      this.results.innerHTML = '';
      return;
    }

    this.saveRecentSearch(query);

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    try {
      const response = await fetch(
        `${this.searchUrl}/suggest?q=${encodeURIComponent(query)}&resources[type]=product&section_id=predictive-search`,
        {
          signal: this.abortController.signal
        }
      );

      const text = await response.text();

      const html = new DOMParser()
        .parseFromString(text, 'text/html');

      const items = html.querySelectorAll('.predictive-search__list-item');

      if (!items.length) {
        this.results.innerHTML = `
          <div class="predictive-empty">
            No products found.
          </div>
        `;
        return;
      }

      let output = '<div class="predictive-search-results">';

      items.forEach((item) => {
        const link = item.querySelector('a');

        if (!link) return;

        const image =
          link.querySelector('img')?.src || '';

        const title =
          link.querySelector('.predictive-search__item-heading')?.textContent || '';

        const price =
          link.querySelector('.price')?.textContent || '';

        output += `
          <a href="${link.href}" class="predictive-product">

            <div class="predictive-product-image">
              <img src="${image}" alt="${title}">
            </div>

            <div>
              <div class="predictive-product-title">
                ${title}
              </div>

              <div class="predictive-product-price">
                ${price}
              </div>
            </div>

          </a>
        `;
      });

      output += '</div>';

      this.results.innerHTML = output;

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    }
  }

  saveRecentSearch(query) {
    let searches =
      JSON.parse(localStorage.getItem('recentSearches')) || [];

    searches =
      searches.filter(item => item !== query);

    searches.unshift(query);

    searches = searches.slice(0, 6);

    localStorage.setItem(
      'recentSearches',
      JSON.stringify(searches)
    );

    this.renderRecentSearches();
  }

  renderRecentSearches() {
    if (!this.recentContainer) return;

    const searches =
      JSON.parse(localStorage.getItem('recentSearches')) || [];

    if (!searches.length) {
      this.recentContainer.innerHTML = '';
      return;
    }

    this.recentContainer.innerHTML =
      searches.map(search => `
        <a
          href="${this.searchUrl}?q=${encodeURIComponent(search)}"
          class="search-pill"
        >
          ${search}
        </a>
      `).join('');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SmartSearchOverlay();
});